$(document).ready(function () {
  $(".featured-articles-slider").slick({
    dots: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 4000,
    arrows: true,
    prevArrow: `<button type="button" class="slick-prev custom-prev">
      <svg width="43" height="38" viewBox="0 0 43 38" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.47468 20.843L17.2812 36.7236C17.7032 37.1456 18.3695 37.3232 19.0359 37.3232C19.7022 37.3232 20.3093 37.1456 20.7313 36.7236L24.9735 32.4813C25.277 32.1778 25.6398 31.3856 25.6398 30.7267C25.6398 30.0678 25.277 29.3348 24.9735 29.0313L19.8651 24.33L40.1137 24.9149C41.6314 24.9149 42.5347 24.0043 42.5347 22.494L42.5347 15.8234C42.5347 14.3131 41.624 13.395 40.1137 13.395L19.8651 13.9799L24.9735 9.27866C25.3363 8.91589 25.6398 8.24958 25.6398 7.58326C25.6398 6.91694 25.3363 6.19139 24.9735 5.82862L20.7313 1.5864C20.4277 1.28285 19.7022 0.986708 19.0359 0.986708C18.3695 0.986707 17.5774 1.28285 17.2812 1.5864L1.46728 17.4596C0.91942 18 0.734331 18.6145 0.734331 19.155C0.734331 19.6954 0.91942 20.2433 1.46728 20.8504L1.47468 20.843Z" fill="#201C1C"/>
      </svg>
    </button>`,
    nextArrow: `<button type="button" class="slick-next custom-next"><svg width="42" height="38" viewBox="0 0 42 38" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M41.2597 17.4676L25.4532 1.58699C25.0312 1.16499 24.3648 0.987305 23.6985 0.987305C23.0322 0.987305 22.4251 1.16499 22.0031 1.58699L17.7609 5.82921C17.4573 6.13276 17.0946 6.92494 17.0946 7.58385C17.0946 8.24276 17.4573 8.97571 17.7609 9.27926L22.8693 13.9805L2.62066 13.3956C1.10294 13.3956 0.199707 14.3063 0.199707 15.8166L0.199707 22.4872C0.199707 23.9975 1.11034 24.9155 2.62066 24.9155L22.8693 24.3306L17.7609 29.0319C17.3981 29.3947 17.0946 30.061 17.0946 30.7273C17.0946 31.3936 17.3981 32.1192 17.7609 32.4819L22.0031 36.7241C22.3067 37.0277 23.0322 37.3238 23.6985 37.3238C24.3648 37.3238 25.157 37.0277 25.4532 36.7241L41.2671 20.851C41.815 20.3105 42 19.696 42 19.1556C42 18.6151 41.815 18.0673 41.2671 17.4602L41.2597 17.4676Z" fill="#201C1C"/>
</svg>
</button>`, // replace with your own SVG if needed
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  });
});
